import EventBlock from './EventBlock'

export { EventBlock }
